import { createFileRoute } from '@tanstack/react-router';
import { ProfileView } from '@/features/employees/profile/profile-view';
import { profileSearchSchema } from '@/features/employees/profile/route-search';
import { guardRoute } from '@/lib/route-guards';

/**
 * A report's profile for managers (FR-MGR-3): no salary, bank or documents (AC-3, AC-6). Same
 * header and tabs as the HR view (T-106) with a note naming the hidden sections; people in the
 * header link within `/team`.
 */
export const Route = createFileRoute('/_app/team_/$employeeId')({
  validateSearch: profileSearchSchema,
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/team');
  },
  component: TeamMemberPage,
});

function TeamMemberPage() {
  const { employeeId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProfileView
      employeeId={employeeId}
      tab={tab}
      breadcrumbs={[{ label: 'My team', to: '/team' }]}
      linkScope="team"
      onTabChange={(next) => {
        void navigate({ search: { tab: next }, replace: true });
      }}
    />
  );
}
